import React from "react";
import { Lock } from "lucide-react";

// Trust badge: small lock icon + "Payments secured by" + Stripe wordmark (brand indigo #635BFF).
export function StripeBadge({ className = "", testid = "stripe-trust-badge" }) {
  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border border-border bg-card px-3.5 py-1.5 text-xs font-semibold text-muted-foreground shadow-sm ${className}`}
    >
      <Lock className="w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400" />
      <span>Payments secured by</span>
      <span className="font-extrabold tracking-tight" style={{ color: "#635BFF" }}>Stripe</span>
    </div>
  );
}
